import React from "react";
import { Shirt, Watch, Glasses, ShoppingBag, Footprints, Gem, Rows3, Minus, Layers } from "lucide-react";

const MAP = {
  top: Shirt, dress: Shirt, jacket: Layers, trousers: Rows3, shoes: Footprints,
  bag: ShoppingBag, watch: Watch, sunglasses: Glasses, necklace: Gem, earrings: Gem,
  bracelet: Gem, ring: Gem, belt: Minus, accessory: Gem, scarf: Minus, tie: Minus,
};

export default function LookIcon({ name, size = 16, className = "" }) {
  const Ico = MAP[name] || Shirt;
  return <Ico size={size} strokeWidth={1.4} className={className} />;
}
